import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Box from 'common/src/components/Box';
import Text from 'common/src/components/Text';
import Image from 'common/src/components/Image';
import Heading from 'common/src/components/Heading';
import FeatureBlock from 'common/src/components/FeatureBlock';
import Container from 'common/src/components/UI/Container';
import ServiceSectionWrapper from './service.style';
import intro from 'common/src/assets/image/saas/Intro.png';
import recommendation from 'common/src/assets/image/saas/Recommendation.png';
import filingStep from 'common/src/assets/image/saas/Filing-Step.png';
import marriage from 'common/src/assets/image/saas/marriage.png';

const StyledBox = styled(Box)`
  display: flex;
  flex-direction: ${props => (props.reverse ? 'column-reverse' : 'column')};
  align-items: center;
  h3 {
    color: #2e49ec;
  }
  width: 100%;
  margin-bottom: 30px;
  @media screen and (min-width: 990px) {
    flex-direction: row;
    justify-content: space-between;
    .col {
      width: 48%;
    }
  }
`;

const ServiceSection = ({
  row,
  col,
  sectionHeader,
  sectionTitle,
  sectionSubTitle,
  featureTitle,
  featureDescription,
  iconStyle,
  contentStyle,
  blockWrapperStyle
}) => {
  const Data = useStaticQuery(graphql`
    query {
      saasJson {
        Service {
          id
          title
          description
          icon
        }
      }
    }
  `);

  return (
    <ServiceSectionWrapper id="feature_section">
      <Container>
        <Box {...sectionHeader}>
          <Text content="OUR FEATURES" {...sectionSubTitle} />
          <Heading content="What Differentiates LoanSense" {...sectionTitle} />
          <h3 style={{ width: '80%', margin: '20px auto', fontWeight: '400' }}>
            We do NOT prioritize refinance. We help people get their loans
            forgiven through government programs. It’s confusing. Check out a
            personal story{' '}
            <a
              href="https://www.youtube.com/watch?v=UOQKRPX_09Q"
              target="_blank"
            >
              here.
            </a>
          </h3>
        </Box>
        <StyledBox {...row} reverse>
          <Box className="col">
            <h3>
              Answer a few questions, update your loans and get a tailored plan
            </h3>
            <p>
              71% who file by themselves unknowingly commit paperwork errors.
            </p>
            <p>
              We are here to help YOU file YOUR paperwork correctly and on time.
            </p>
          </Box>
          <Box className="col">
            <Image src={intro} />
          </Box>
        </StyledBox>
        <StyledBox {...row}>
          <Box className="col">
            <Image src={recommendation} height="200px" />
          </Box>
          <Box className="col">
            <h3>Customize your loan plan for public and private loans</h3>
            <p>
              Don't know which loan plan is the best based on your employment or
              income?
            </p>
            <p>We'll tell you.</p>
          </Box>
        </StyledBox>
        <StyledBox {...row} reverse>
          <Box className="col">
            <h3>File paperwork & Reminders</h3>
            <p>Answer a few questions and we’ll help you file</p>
            <p>
              71% who file by themselves unknowingly commit paperwork errors.
            </p>
            <p>99% who file by themselves get rejected. </p>
            <p>
              We are here to help YOU file YOUR paperwork correctly and on time.
            </p>
          </Box>
          <Box className="col">
            <Image src={filingStep} />
          </Box>
        </StyledBox>
        <StyledBox {...row}>
          <Box className="col">
            <Image src={marriage} />
          </Box>
          <Box className="col">
            <h3>Understand how to file your income taxes</h3>
            <p>
              <b>
                Married and not sure if it will affect your taxes? Our
                calculator will show you.
              </b>
            </p>
          </Box>
        </StyledBox>
      </Container>
    </ServiceSectionWrapper>
  );
};

// ServiceSection style props
ServiceSection.propTypes = {
  sectionHeader: PropTypes.object,
  row: PropTypes.object,
  col: PropTypes.object,
  sectionTitle: PropTypes.object,
  sectionSubTitle: PropTypes.object,
  featureTitle: PropTypes.object,
  featureDescription: PropTypes.object
};

// ServiceSection default style
ServiceSection.defaultProps = {
  // section header default style
  sectionHeader: {
    mb: ['50px', '50px', '50px', '80px']
  },
  // sub section default style
  sectionSubTitle: {
    as: 'span',
    display: 'block',
    textAlign: 'center',
    fontSize: '14px',
    letterSpacing: '0.15em',
    fontWeight: '700',
    color: '#5268db',
    mb: '10px'
  },
  // section title default style
  sectionTitle: {
    textAlign: 'center',
    fontSize: ['20px', '24px'],
    fontWeight: '500',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: '0'
  },
  // feature row default style
  row: {
    flexBox: true,
    flexWrap: 'wrap'
  },
  // feature col default style
  col: {
    width: [1, 1 / 2, 1 / 2, 1 / 3]
  },
  // feature block wrapper default style
  blockWrapperStyle: {
    p: ['30px', '20px', '20px', '20px']
  },
  // feature icon default style
  iconStyle: {
    width: ['70px', '80px'],
    height: ['70px', '80px'],
    borderRadius: '50%',
    bg: '#93d26e',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: ['32px', '36px'],
    color: '#ffffff',
    overflow: 'hidden',
    mb: '30px',
    borderBottomLeftRadius: '50%'
  },
  // feature content default style
  contentStyle: {
    textAlign: 'left',
    mt: '-5px'
  },
  // feature title default style
  featureTitle: {
    fontSize: ['18px', '20px'],
    fontWeight: '400',
    color: '#0f2137',
    lineHeight: '1.5',
    letterSpacing: '-0.020em',
    mb: '10px'
  },
  // feature description default style
  featureDescription: {
    fontSize: '15px',
    lineHeight: '1.75',
    color: '#343d4ccc'
  }
};

export default ServiceSection;
